import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.2 10.45c-.449-.27-1.162-.772-2.013-1.621-.854-.854-1.355-1.57-1.625-2.02-.19-.314-.187-.695-.043-1.032l.868-2.03L3.78 0c-6.136 1.732-3.936 7.351.475 11.76 4.41 4.41 10.009 6.585 11.745.455L12.252 9.61l-2.007.878c-.34.149-.726.153-1.045-.038M4.795 3.91l-.563 1.317c-.286.67-.333 1.534.13 2.304.326.543.897 1.35 1.836 2.288.933.933 1.737 1.503 2.28 1.83.778.469 1.654.417 2.329.122l1.29-.565 2.23 1.551c-.33.749-.715 1.191-1.08 1.448-.479.337-1.094.474-1.907.35-1.725-.26-3.963-1.653-6.096-3.785S1.712 6.394 1.446 4.663c-.126-.817.01-1.433.346-1.912.255-.365.697-.75 1.446-1.078z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneOutlinedSize16Glyph.displayName = 'PhoneOutlinedSize16Glyph';
